import React from "react";
import {
  Alert,
  AutoComplete,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
} from "antd";
import styles from "../company-directory/directory.module.css";

const permissionOptions = (templates = []) =>
  templates.map((value) => ({
    value,
    label: value === "Default" ? "Apply Permission Template Later" : value,
  }));

const BulkEditForm = ({
  count,
  companies,
  permissions,
  permissionsLoading,
  permissionsError,
  saving,
  error,
  onRetryPermissions,
  onCancel,
  onSubmit,
}) => {
  const [form] = Form.useForm();
  const company = Form.useWatch("inviteeCompany", form);
  const address = Form.useWatch("inviteeCompanyAddress", form);
  const companyPermission = Form.useWatch(
    "inviteeCompanyPermission",
    form,
  );
  const projectPermission = Form.useWatch(
    "inviteeProjectPermission",
    form,
  );
  const hasChanges = Boolean(
    company?.trim() || address?.trim() || companyPermission || projectPermission,
  );

  return (
    <Modal
      open
      title="Bulk Edit"
      width={720}
      onCancel={onCancel}
      onOk={() => form.submit()}
      okText="Save Changes"
      confirmLoading={saving}
      okButtonProps={{ disabled: !hasChanges }}
      cancelButtonProps={{ disabled: saving }}
      closable={!saving}
      maskClosable={!saving}
      keyboard={!saving}
      destroyOnHidden
    >
      <p className={`${styles.paragraph} ${styles.secondary}`}>
        Update {count} selected {count === 1 ? "contact" : "contacts"}. Leave
        a field blank to keep its current value.
      </p>
      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
        disabled={saving}
      >
        {error && (
          <Alert
            type="error"
            showIcon
            message={error}
            style={{ marginBottom: 20 }}
          />
        )}
        {permissionsError && (
          <Alert
            type="error"
            showIcon
            message={permissionsError}
            action={
              <button
                type="button"
                className={styles.retryLink}
                onClick={onRetryPermissions}
              >
                Retry
              </button>
            }
            style={{ marginBottom: 20 }}
          />
        )}
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item name="inviteeCompany" label="Company Name">
              <AutoComplete
                options={companies}
                filterOption={(input, option) =>
                  option.value.toLowerCase().includes(input.toLowerCase())
                }
                onSelect={(_, option) =>
                  form.setFieldValue(
                    "inviteeCompanyAddress",
                    option.address || "",
                  )
                }
                placeholder="Keep current company"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="inviteeCompanyAddress"
              label="Company Address"
            >
              <Input
                placeholder="Keep current address"
                autoComplete="street-address"
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="inviteeCompanyPermission"
              label="Company Permissions Template"
            >
              <Select
                allowClear
                showSearch
                optionFilterProp="label"
                placeholder="Keep current template"
                loading={permissionsLoading}
                options={permissionOptions(
                  permissions.companyAssignablePermissions,
                )}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="inviteeProjectPermission"
              label="Project Permissions Template"
            >
              <Select
                allowClear
                showSearch
                optionFilterProp="label"
                placeholder="Keep current template"
                loading={permissionsLoading}
                options={permissionOptions(
                  permissions.projectAssignablePermissions,
                )}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default BulkEditForm;
